module.exports = __webpack_public_path__ + "ee400d2b739af66ffc7dc60a0265da78.png";